// UserMailTemplateコンポーネントをインポート
// ユーザー向けの「仮パスワード発行」ページ用テンプレートとして使用
import UserMailTemplate from "../templates/UserMailTemplate";

/**
 * UserMailPageコンポーネント
 * ユーザー向けの「仮パスワード発行」ページを表示するためのコンポーネント
 * UserMailTemplateを利用して仮パスワード発行画面を構築
 */

const UserMailPage = () => {

    // 仮パスワード発行ページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserMailTemplateをそのまま利用
    return (
        <UserMailTemplate />
    );
}

// UserMailPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserMailPage;